import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";
import { Sidebar } from "./components";
import { useBranchDetails } from "hooks";

const MainLayout = ({ children }) => {
  const { t: getLabel } = useTranslation(LangConstant.NS_COMMON);
  const { checkHealth } = useBranchDetails();

  const [licenseDayRemaining, setLicenseDayRemaining] = useState(99999);
  const [licenseExpiryTime, setLicenseExpiryTime] = useState("");
  const [isExpired, setIsExpired] = useState(false);

  // State quản lý Sidebar co/giãn lưu ở localStorage
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return localStorage.getItem("trios_sidebar_collapsed") === "true";
  });

  const handleToggleSidebar = () => {
    setIsCollapsed(prev => {
      const newVal = !prev;
      localStorage.setItem("trios_sidebar_collapsed", String(newVal));
      return newVal;
    });
  };

  // Đồng bộ class navbar-vertical-collapsed của Tabler lên thẻ body
  useEffect(() => {
    if (isCollapsed) {
      document.body.classList.add("navbar-vertical-collapsed");
    } else {
      document.body.classList.remove("navbar-vertical-collapsed");
    }
  }, [isCollapsed]);

  useEffect(() => {
    if (checkHealth && checkHealth.data) {
      if (checkHealth.data.license_expiry_time) {
        let expiry_time = new Date(checkHealth.data.license_expiry_time).getTime();
        let current_time = Date.now();
        if (expiry_time > current_time) {
          setLicenseDayRemaining((expiry_time - current_time) / (1000 * 60 * 60 * 24));
          setLicenseExpiryTime(
            new Date(expiry_time).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }),
          );
        } else {
          setIsExpired(true);
        }
      }
    }
  }, [checkHealth]);

  return (
    <div className="page">
      {/* Warning License Banner */}
      {licenseDayRemaining <= 7 && (
        <div 
          className={`alert alert-${licenseDayRemaining > 3 ? "warning" : "danger"} m-0 rounded-0 text-center`}
          style={{ zIndex: 1050, position: "relative" }}
        >
          <div className="container-xl">
            <strong>
              {isExpired ? (
                <>Máy chủ đã hết hạn vào ngày {licenseExpiryTime}. Vui lòng liên hệ +84-24-3204-5456 để gia hạn sử dụng.</>
              ) : (
                <>Máy chủ sẽ hết hạn vào ngày {licenseExpiryTime}. Vui lòng liên hệ +84-24-3204-5456 để gia hạn sử dụng.</>
              )}
            </strong>
          </div>
        </div>
      )}

      {/* Sidebar bên trái */}
      <Sidebar isCollapsed={isCollapsed} onToggleCollapse={handleToggleSidebar} />

      {/* Main Wrapper bên phải */}
      <div className="page-wrapper">
        {/* Main Content Area */}
        <div className="page-body">
          <div className="container-xl">
            {children}
          </div>
        </div>

        {/* Footer */}
        <footer className="footer footer-transparent d-print-none py-3 border-top mt-auto">
          <div className="container-xl">
            <div className="row text-center align-items-center justify-content-center">
              <div className="col-12 col-lg-auto">
                <span className="text-secondary small">
                  {getLabel(LangConstant.TXT_APP_COPYRIGHT)}
                </span>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default MainLayout;
